import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-xl font-bold text-foreground-900 tracking-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              不良研究所
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              深度研究与内容探索平台，汇聚多元视角与独立思考，带你发现主流之外的真实世界。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  加入我们
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  内容合作
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">法律信息</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  知识产权声明
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 不良研究所. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            深度研究内容 · 独立创意研究 · 非主流内容探索
          </p>
        </div>
      </div>
    </footer>
  );
}